export class DigiformaApiError extends Error {
  constructor(message: string, options?: { cause?: Error }) {
    super(message, options);
  }
}
